import styled from "styled-components";
import { Flex, Anchor, Icon } from "@ebscois/react-component-library";

export const StyledWrapper = styled(Flex)`
  margin-left: auto;
  font-size: ${({ theme }) => theme.font.size.sm};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: 0;
  }
  @media print {
    display: none;
  }
`;

export const StyledAnchor = styled(Anchor)`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const StyledIcon = styled(Icon)`
  vertical-align: middle;
  margin-right: ${({ theme }) => theme.space.sm};
`;

export const StyledItalicText = styled.span`
  font-style: italic;
`;
